import React from 'react';
import WalletMenu from '../../../wallet/WalletMenu';

const PageBarActions = () => <WalletMenu />;
export default PageBarActions;
